// v2 campaign catalog lane — owned by the same agent as app/v2/slot1.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot1Catalog: V2CatalogEntry[] = [
  {
    rank: 3,
    title: 'Order Status',
    route: '/orders/status2',
    faithfulRoute: '/browse/orders-status',
    score: 20,
    blurb:
      'Answers "is the floor late, and how far through picking is it?" with a funnel + alert band and four question-shaped column presets, instead of scrolling 80 columns sideways.',
  },
  {
    rank: 4,
    title: 'Tag Order Search',
    route: '/orders/waving2',
    faithfulRoute: '/browse/order-tag-search',
    score: 20,
    blurb:
      'Shows the shape of the order set you are about to wave — already-waved, ship-by spread, type and priority mix — and turns the 22-icon toolbar into a build-a-wave workflow with a post-submit handoff.',
  },
  {
    rank: 5,
    title: 'Order Inquiry',
    route: '/orders/inquiry2',
    faithfulRoute: '/orders/inquiry/:orderId/:releaseNum',
    score: 19,
    blurb:
      'Puts the order pipeline and its blockers above the fold and groups the 11 tabs by the question they answer, so the 30-icon toolbar stops being the only map.',
  },
  {
    rank: 6,
    title: 'Wave Status',
    route: '/waves/status2',
    faithfulRoute: '/browse/wave-status',
    score: 19,
    blurb:
      'Answers "which of my waves is stuck?" with a wave-floor KPI header, per-row picked/fillrate meters and load-plan + restock alerts, over a lifecycle rail (Open → Closed) and 35 icons regrouped by intent.',
  },
  {
    rank: 12,
    title: 'Wave Detail',
    route: '/orders/wave-detail2',
    faithfulRoute: '/orders/wave-detail/:warehouseId/:waveSeqNum',
    score: 18,
    blurb:
      'Turns "is this wave healthy?" into one scorecard whose tiles ARE the seven tab counts, so the answer stops requiring four tab visits and a mental comparison.',
  },
  {
    rank: 14,
    title: 'Automatic Waving',
    route: '/waves/auto2',
    faithfulRoute: '/reports/wave',
    score: 18,
    blurb:
      'Draws the LIMITS block as meters — planned vs actual vs limit — so "will this profile produce a wave that fits?" is visible instead of derived, over a Profile → Criteria → Candidates → Commit rail.',
  },
  {
    rank: 23,
    title: 'Order Search',
    route: '/orders/search2',
    faithfulRoute: '/orders/search',
    score: 17,
    blurb:
      'Shows the SHAPE of the result set — status mix, pieces/weight/cube/value, the seven booleans as filter chips — over a rail of saved question-shaped searches, with a persistent line panel that names which line is holding each order up.',
  },
  {
    rank: 24,
    title: 'Picks for Work',
    route: '/manage/picks2',
    faithfulRoute: '/manage/picks',
    score: 17,
    blurb:
      'Answers "how badly is this set shorting?" with a cut-% headline over whichever of the nine modes you arrived by, and collapses the three container Y/N columns into one chip plus a required-but-unavailable alert.',
  },
  {
    rank: 26,
    title: 'Order Status Dashboard',
    route: '/orders/dashboard2',
    faithfulRoute: '/orders/status-dashboard',
    score: 17,
    blurb:
      'Turns the category swatches into a funnel with money and urgency attached — count · value at risk · most urgent per bucket — plus per-bucket work-type mix and a Staging tile for the dock counters the current page never synthesises.',
  },
];
